import axios from "axios";

export const api = axios.create({
    baseURL: `${process.env.REACT_APP_DOMAIN_BASE}/api`,
    withCredentials: true,
    headers: {
        "App-Ver": process.env.REACT_APP_VERSION,
    },
});

export const apiWidget = axios.create({
    baseURL: `${process.env.REACT_APP_DOMAIN_BASE}/api/widget`,
    withCredentials: true,
    headers: {
        "App-Ver": process.env.REACT_APP_VERSION,
    },
});


export const accounts = axios.create({
    baseURL: `${process.env.REACT_APP_DOMAIN_ACCOUNTS}`,
    withCredentials: true,
});

export const web = axios.create({
    baseURL: `${process.env.REACT_APP_DOMAIN_BASE}/api/public`,
    withCredentials: true,
    headers: {
        "App-Ver": process.env.REACT_APP_VERSION,
    },
});